import React, { FC } from 'react';

import { CommonError } from 'src/components/common-error/common-error';
import { i18n } from 'src/i18n';
import { owlImageProps } from 'src/resources/images';

export const PageInflightOrder: FC = () => (
  <CommonError
    title={i18n.page.error.inflightOrder.title}
    subtitle={[i18n.page.error.inflightOrder.inflightOrder, i18n.page.error.inflightOrder.cancelOrder]}
    image={owlImageProps}
  />
);
